import { put, takeEvery } from "redux-saga/effects";
import {
  fetchOpportunityHistoryLogDetails,
  setIsOpportunityHistoryDetailsModalLoading,
  setIsOpportunityHistoryDetailsModalOpen,
  setOpportunityHistoryDetailsAllocationLogs,
  setOpportunityHistoryDetailsImportLogs
} from "../../store/actions";
import { getWithToken } from "../../api/network";

export function* getOpportunityHistoryLogDetailsSaga() {
  yield takeEvery(fetchOpportunityHistoryLogDetails, function* ({ payload }) {

    yield put(setIsOpportunityHistoryDetailsModalLoading(true));
    yield put(setIsOpportunityHistoryDetailsModalOpen(true));

    const getLogsUrl = () => {
      switch (payload.type) {
        case 'Allocations':
          return `/api/underwrite/workflow/opportunityHistory/details/GetAllocationLogsByTxnOppId/${payload.txnOppId}`
        case 'Reload Import':
          return `/api/underwrite/workflow/opportunityHistory/details/GetEventLogByReloadId/${payload.reloadId}`
        default:
          return `/api/underwrite/import/history/getEventHistoryImportLogsByImportId?importId=${payload.importId}`
      }
    }

    const logsUrl = getLogsUrl()
    const logsResponse = yield getWithToken(logsUrl);
    const logResponseData = yield logsResponse.json();
    const logsString = logResponseData.join('\r\n');
    const logsStringFormatted = logsString.replace(/\\r\\n/gm, '\r\n');

    const setLogsFunc = payload.type === 'Allocations' ? setOpportunityHistoryDetailsAllocationLogs : setOpportunityHistoryDetailsImportLogs
    yield put(setLogsFunc(logsStringFormatted))

    yield put(setIsOpportunityHistoryDetailsModalLoading(false));
  });
}